var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#2C1C5F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#53389E",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 26.0001V32.0112C21 32.3702 21 32.5496 21.0547 32.7081C21.103 32.8482 21.1819 32.9759 21.2856 33.0817C21.4029 33.2015 21.5634 33.2818 21.8845 33.4423L27.2845 36.1423C27.5468 36.2735 27.678 36.3391 27.8156 36.3649C27.9375 36.3877 28.0625 36.3877 28.1844 36.3649C28.322 36.3391 28.4532 36.2735 28.7155 36.1423L34.1155 33.4423C34.4366 33.2818 34.5971 33.2015 34.7144 33.0817C34.8181 32.9759 34.897 32.8482 34.9453 32.7081C35 32.5496 35 32.3702 35 32.0112V26.0001M18 24.5001L27.6422 19.679C27.7734 19.6134 27.839 19.5806 27.9078 19.5677C27.9687 19.5562 28.0313 19.5562 28.0922 19.5677C28.161 19.5806 28.2266 19.6134 28.3578 19.679L38 24.5001L28.3578 29.3212C28.2266 29.3868 28.161 29.4196 28.0922 29.4325C28.0313 29.4439 27.9687 29.4439 27.9078 29.4325C27.839 29.4196 27.7734 29.3868 27.6422 29.3212L18 24.5001Z",
    stroke: "#9E77ED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHat);
export default __webpack_public_path__ + "static/media/hat.e61fd8c5769b837cc2da5f954c07da48.svg";
export { ForwardRef as ReactComponent };